import { ref, reactive, computed,watch, onMounted, onBeforeMount, getCurrentInstance, onBeforeUnmount, ComponentInternalInstance, toRefs } from 'vue'
import { $enum } from '@/global'
import { getUserKeybinding, setUserKeybinding, getKeyTypeList, saveUserJoystickSpecification } from '@/service'
import {useStore} from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import {ChannelItem,keyTypeItem} from '@/types/baseInterFace'
export default function useRemote(){
    const store = useStore()
    const { proxy } = getCurrentInstance() as ComponentInternalInstance
    let messageDuration = 1200
    const state = reactive({ 
        romoteCenect:$enum.SWITCH_STATUS.OFF,
        chanleList: [] as ChannelItem[],
        timer:null as number | null,
        remoteID:'',
        loading:false,
        remoteDirection:0,
        actionType:0,
        stepTitle:'遥感中位',
        stepContent:'保持摇杆中位，点击“确定”',
        showModal:false,
        keyTypeListA:[] as keyTypeItem[],
        keyTypeListB:[{
            id: 0,
            keyCode: "",
            keyName: "无",
        }] as keyTypeItem[],
        calibrateDisabled:true,
        leftX:50,
        leftY:50,
        rightX:50,
        rightY:50,
        isGetStickValueStart:false, //是否开始获取摇杆最值
        isGetStickValueEnd:true,//是否结束获取摇杆最值
        stickType1Min:-0.3,
        stickType1Max:0.3,
        stickType2Min:-0.3,
        stickType2Max:0.3,
        stickType3Min:-0.3,
        stickType3Max:0.3,
        stickType4Min:-0.3,
        stickType4Max:0.3,
        progress5Num:0,
        progress5Timer:null as number | null,
        axesArray:[] as any[],
        showPrompt:false,
        confirmLoading:false,
        gamepadIndex: null as number | null,
        connectedRemoteOptions: [] as { label: string; value: string }[],
        selectedGamepadIndex: '',
    })
    let isHandlingGamepadsChange = false
    let connectionWatchTimer: number | null = null
    const stickTypeList = [
        { label: '无', value: 0},{ label: '左摇杆-左右', value: 1 },{ label: '左摇杆-上下', value: 2 },{ label: '右摇杆-左右', value: 3 },{ label: '右摇杆-上下', value:4 }
    ]
    const remoteIcon = computed(() => {
        return state.romoteCenect == $enum.SWITCH_STATUS.ON ? require("@assets/images/connect.png") : require("@assets/images/disconnect.png")
    })
    const remoteName = computed(() => {
        return state.romoteCenect == $enum.SWITCH_STATUS.ON ? state.remoteID : '遥控器未连接'
    })
    const disconnect = () => {
        return state.romoteCenect == $enum.SWITCH_STATUS.ON ? false : true
    };
    ////////////////////////////////////////////////////////  方法
    const initData = () => {
        state.romoteCenect= $enum.SWITCH_STATUS.OFF;
        state.remoteID = '遥控器未连接';
        state.gamepadIndex = null;
        state.connectedRemoteOptions = [];
        state.selectedGamepadIndex = '';
        state.chanleList = []
        let arr = []
        for (let i = 1; i <= 4; i++) {
            let item: ChannelItem = {
                index: i,
                name: '通道' + i,
                value: -1,
                keyCode:"",
                keyName:"",
                reverse: false,
                keyValue:"",
                valueType:1,
                stickCenterValue:0,
                stickMinValue:-1,
                stickMaxValue:1,
                stickType:0,
            }
            arr.push(item)
        }
        state.chanleList = [...arr];
        state.keyTypeListA = []
        state.keyTypeListB = [{
            id: 0,
            keyCode: "",
            keyName: "无",
        }]
    }

    const getKeyBindData = async (axesArray: any[], userId: string | number) => { 
        let param = {
            userId:userId,
            deviceType:1,
            joystickSpecification:state.remoteID
        }
        if(userId == -1){
            state.confirmLoading = true;
        }
        let {code,data} = await getUserKeybinding(param)
        if(userId == -1){
            state.confirmLoading = false;
            state.showPrompt = false
        }
        if(code != $enum.EnumResult.SUCCESS){
            proxy?.vknMessage.error({
                message:"获取遥控器数据失败！",
                duration: messageDuration,
            })
            return;
        }
        let {keyBindingList} = data as any || []
        const calibrateDisabledList=[]
        if(userId == -1){
            // 先重置所有通道的默认值（恢复默认时需要）
            state.chanleList.forEach(item => {
                item.reverse = false
                item.keyCode = ""
                item.keyName = ""
                item.stickType = 0
                item.stickCenterValue = 0
                item.stickMinValue = -1
                item.stickMaxValue = 1
            })
        }
        

        if(Array.isArray(keyBindingList) && keyBindingList.length){
            // 存的时候把按钮的keyValue减去了axes长度，所以这里要重新映射下
            keyBindingList = keyBindingList.map(item=>{
                if(item.valueType==2){
                    item.keyValue = (Number(item.keyValue)  + axesArray.length)+'';
                }
                return item;
            });


            keyBindingList.forEach((item:any,index:number)=>{
                let keyIndex = item.keyValue;
                if(state.chanleList[keyIndex]){
                    state.chanleList[keyIndex].reverse = item.isInverse;
                    state.chanleList[keyIndex].keyCode = item.keyCode;
                    state.chanleList[keyIndex].keyName = item.keyName;
                    state.chanleList[keyIndex].keyValue = item.keyValue;
                    state.chanleList[keyIndex].valueType = item.valueType;
                    state.chanleList[keyIndex].stickCenterValue = item.stickCenterValue;
                    state.chanleList[keyIndex].stickMinValue = item.stickMinValue;
                    state.chanleList[keyIndex].stickMaxValue = item.stickMaxValue;
                    state.chanleList[keyIndex].stickType = item.stickType || 0;
                    if(item.stickType===1 || item.stickType===2 || item.stickType===3 || item.stickType===4){
                        calibrateDisabledList.push(item.stickType);
                    }
                }

            })
            if(calibrateDisabledList.length===4){
                state.calibrateDisabled=false
            }else{
                state.calibrateDisabled=true
            }
        }
    }
    const onGetKeyTypeList = async ()=>{ 
        let param = {
            joystickSpecification:state.remoteID
        }
        let {code,data} = await getKeyTypeList(param)
        if(code == $enum.EnumResult.SUCCESS){
            state.keyTypeListA = [
                {
                    id: 0,
                    keyCode: "",
                    keyName: "无"
                },
            ];
            state.keyTypeListB = [
                {
                    id: 0,
                    keyCode: "",
                    keyName: "无"
                },
            ];
            const list = data as keyTypeItem[];
            list.forEach(item=>{
                if(item.id===1 || item.id===2 || item.id===3 || item.id===4){
                    state.keyTypeListA.push(item);
                }else{
                    state.keyTypeListB.push(item);
                }
            })
        }
    }
    function inputToPercent(item:any, reverse = false) {
        const leftRange = item.stickCenterValue - item.stickMinValue;
        const rightRange = item.stickMaxValue - item.stickCenterValue;
         let percent=0;
        if (item.value < item.stickCenterValue) {
            percent= 50 * (1 - (item.stickCenterValue - item.value) / (leftRange  || 1));
        } else {
            percent= 50 + 50 * ((item.value - item.stickCenterValue) / (rightRange || 1));
        }
        if (reverse) {
            percent = 100 - percent;
        }
        return percent
    }
    const updateValue=(item:any)=>{
        if (item.stickCenterValue != undefined && item.stickMinValue != undefined && item.stickMaxValue != undefined && (item.stickCenterValue != 0 || item.stickMinValue != -1 || item.stickMaxValue != 1)){
            if (item.value >= item.stickCenterValue) {
                item.value = (item.value - item.stickCenterValue) / (item.stickMaxValue - item.stickCenterValue);
            } else if (item.value < item.stickCenterValue) {
                item.value = - (item.value - item.stickCenterValue) / (item.stickMinValue - item.stickCenterValue);
            }
        }
        if (item.isInverse) {
            item.value = -item.value ;
        }
    }
    // 获取当前所有已连接的有效遥控器
    const getConnectedGamepads = (): Gamepad[] => {
        const gamepads = navigator.getGamepads();
        const connectedList: Gamepad[] = [];
        if (gamepads) {
            for (let i = 0; i < gamepads.length; i++) {
                const gp = gamepads[i];
                if (gp && gp.connected && Array.isArray(gp.axes) && gp.axes.length > 0) {
                    connectedList.push(gp);
                }
            }
        }
        return connectedList;
    }

    const updateConnectedRemoteOptions = (connectedList: Gamepad[]) => {
        const idCount: Record<string, number> = {};
        state.connectedRemoteOptions = connectedList.map((gp) => {
            const count = idCount[gp.id] || 0;
            idCount[gp.id] = count + 1;
            const duplicateTotal = connectedList.filter((item) => item.id === gp.id).length;
            return {
                label: duplicateTotal > 1 ? `${gp.id} (${count + 1})` : gp.id,
                value: String(gp.index),
            };
        });
    }

    const stopAnimation = () => {
        if (state.timer) {
            cancelAnimationFrame(state.timer)
            state.timer = null
        }
    }

    const isGamepadStillConnected = (gamepadIndex: number | null): boolean => {
        if (gamepadIndex == null) return false
        const gamepads = navigator.getGamepads()
        const gp = gamepads[gamepadIndex]
        return !!(gp && gp.connected && Array.isArray(gp.axes) && gp.axes.length > 0)
    }

    const startConnectionWatch = () => {
        if (connectionWatchTimer) return
        connectionWatchTimer = window.setInterval(() => {
            const connectedList = getConnectedGamepads()

            if (state.romoteCenect === $enum.SWITCH_STATUS.ON) {
                const currentValid = isGamepadStillConnected(state.gamepadIndex)
                if (connectedList.length === 0 || !currentValid) {
                    handleGamepadsChange()
                } else if (connectedList.length !== state.connectedRemoteOptions.length) {
                    updateConnectedRemoteOptions(connectedList)
                }
            } else if (connectedList.length > 0) {
                handleGamepadsChange()
            }
        }, 200)
    }

    const stopConnectionWatch = () => {
        if (connectionWatchTimer) {
            clearInterval(connectionWatchTimer)
            connectionWatchTimer = null
        }
    }

    const resetCalibrationState = () => {
        state.leftX = 50;
        state.leftY = 50;
        state.rightX = 50;
        state.rightY = 50;
        state.isGetStickValueStart = false;
        state.isGetStickValueEnd = true;
        state.showModal = false;
        state.calibrateDisabled = true;
    }

    const initGamepad = async (gpObj: Gamepad): Promise<void> => {
        if (!gpObj || (Array.isArray(gpObj.axes) && gpObj.axes.length == 0) || !gpObj.connected) {
            return
        }

        if (state.timer) {
            cancelAnimationFrame(state.timer)
            state.timer = null
        }

        resetCalibrationState()
        const targetIndex = gpObj.index
        state.remoteID = gpObj.id
        state.gamepadIndex = targetIndex
        state.selectedGamepadIndex = String(targetIndex)
        state.romoteCenect = $enum.SWITCH_STATUS.ON;
        state.chanleList = []
        let axesArray: ChannelItem[] = []
        state.axesArray = axesArray;
        let buttonsArray: ChannelItem[] = []
        gpObj.axes.forEach((axis:any, index:any) => {
            let item: ChannelItem = {
                index: index + 1,
                name: `通道${index + 1}`,
                reverse: false,
                value: axis,
                value2: axis,
                keyCode:"",
                keyName:"",
                keyValue:index,
                valueType:1,
                stickCenterValue:0,
                stickMinValue:-1,
                stickMaxValue:1,
                stickType:0,
            }
            axesArray.push(item)
        })
        gpObj.buttons.forEach((button:any, index:any) => {
            let item: ChannelItem = {
                index: gpObj.axes.length +index+1,
                name: `通道${gpObj.axes.length +index+1}`,
                reverse: false,
                value: button.value,
                keyCode:"",
                keyName:"",
                keyValue:gpObj.axes.length+index,
                valueType:2,
                stickCenterValue:null,
                stickMinValue:null,
                stickMaxValue:null,
                stickType:0,
            }
            buttonsArray.push(item)
        })
        state.chanleList = [...axesArray,...buttonsArray]
        await getKeyBindData(axesArray, store.state.persistence.userInfo.userId);
        await onGetKeyTypeList()

        if (!isGamepadStillConnected(targetIndex) || state.gamepadIndex !== targetIndex) {
            return
        }

        function animation(){
            const gamepads = navigator.getGamepads()
            const gp = state.gamepadIndex != null ? gamepads[state.gamepadIndex] : null
            if(!gp || !gp.connected) {
                stopAnimation()
                handleGamepadsChange()
                return
            }
            const axesArray: ChannelItem[] = []
            const buttonsArray: ChannelItem[] = []
            state.chanleList.forEach((item)=>{
                if(item.valueType == 1){
                    axesArray.push(item)
                }else{
                    buttonsArray.push(item)
                }
            })
            const updatedAxesArray = axesArray.map((ch, index) => {
                return { ...ch, value: gp.axes[index] };
            });
            const updatedButtonsArray = buttonsArray.map((ch, index) => {
                return { ...ch, value: gp.buttons[index].value };
            });
            let addAxesArray: ChannelItem[] = []
            let addButtonsArray: ChannelItem[] = []
            if (gp.axes.length > axesArray.length) {
                addAxesArray = gp.axes.slice(axesArray.length).map((axis:any, newIndex:number) => ({
                    index: axesArray.length + newIndex + 1,
                    name: `通道${axesArray.length + newIndex + 1}`,
                    reverse: false,
                    value: axis,
                    keyCode:"",
                    keyName:"",
                    keyValue:axesArray.length + newIndex,
                    valueType:1,
                    stickCenterValue:0,
                    stickMinValue:-1,
                    stickMaxValue:1,
                    stickType: 0,
                }));
            }
            if(gp.buttons.length > buttonsArray.length){
                addButtonsArray = gp.buttons.slice(buttonsArray.length).map((button:any, newIndex:number) => ({
                    index: buttonsArray.length + newIndex + 1,
                    name: `通道${buttonsArray.length + newIndex + 1}`,
                    reverse: false,
                    value: button.value,
                    keyCode:"",
                    keyName:"",
                    keyValue:buttonsArray.length + newIndex,
                    valueType:2,
                    stickCenterValue:null,
                    stickMinValue:null,
                    stickMaxValue:null,
                    stickType: 0,
                }))
            }
            state.chanleList = [...updatedAxesArray,...addAxesArray, ...updatedButtonsArray, ...addButtonsArray]

            state.chanleList.forEach(item=>{

                if(item.stickType===1){
                    if(item.stickCenterValue && item.value<=item.stickCenterValue+0.05 && item.value>=item.stickCenterValue-0.05 ){
                        item.value = item.stickCenterValue;
                    }
                    if(state.isGetStickValueStart && !state.isGetStickValueEnd){
                        if(item.value< state.stickType1Min){
                            state.stickType1Min = item.value
                        }
                        if(item.value> state.stickType1Max){
                            state.stickType1Max = item.value
                        }
                    }
                    const value= inputToPercent(item,item.reverse)
                    const percent = Math.max(0, Math.min(100, value));
                    state.leftX = percent;

                }else if(item.stickType===2){
                    if(item.stickCenterValue && item.value<=item.stickCenterValue+0.05 && item.value>=item.stickCenterValue-0.05 ){
                        item.value = item.stickCenterValue;
                    }
                    if(state.isGetStickValueStart && !state.isGetStickValueEnd){
                        if(item.value< state.stickType2Min){
                            state.stickType2Min = item.value
                        }
                        if(item.value> state.stickType2Max){
                            state.stickType2Max = item.value
                        }
                    }
                    const value= inputToPercent(item,!item.reverse)
                    const percent = Math.max(0, Math.min(100, value));
                    state.leftY = percent;
                }else if(item.stickType===3){
                    if(item.stickCenterValue && item.value<=item.stickCenterValue+0.05 && item.value>=item.stickCenterValue-0.05 ){
                        item.value = item.stickCenterValue;
                    }
                    if(state.isGetStickValueStart && !state.isGetStickValueEnd){
                        if(item.value< state.stickType3Min){
                            state.stickType3Min = item.value
                        }
                        if(item.value> state.stickType3Max){
                            state.stickType3Max = item.value
                        }
                    }
                    const value= inputToPercent(item,item.reverse)
                    const percent = Math.max(0, Math.min(100, value));
                    state.rightX = percent;
                }else if(item.stickType===4){
                    if(item.stickCenterValue && item.value<=item.stickCenterValue+0.05 && item.value>=item.stickCenterValue-0.05 ){
                        item.value = item.stickCenterValue;
                    }
                    if(state.isGetStickValueStart && !state.isGetStickValueEnd){
                        if(item.value< state.stickType4Min){
                            state.stickType4Min = item.value
                        }
                        if(item.value> state.stickType4Max){
                            state.stickType4Max = item.value
                        }
                    }
                    const value= inputToPercent(item,!item.reverse)
                    const percent = Math.max(0, Math.min(100, value));
                    state.rightY = percent;
                }
            })
            state.timer = requestAnimationFrame(animation)
        }
        animation()
    }

    const handleGamepadsChange = async () => {
        if (isHandlingGamepadsChange) return
        isHandlingGamepadsChange = true
        try {
            const connectedList = getConnectedGamepads();
            updateConnectedRemoteOptions(connectedList);

            if (connectedList.length === 0) {
                stopAnimation();
                initData();
                return;
            }

            state.romoteCenect = $enum.SWITCH_STATUS.ON;

            const currentGp = state.gamepadIndex != null
                ? connectedList.find((gp) => gp.index === state.gamepadIndex)
                : null;

            if (currentGp) {
                return;
            }

            const matchById = state.remoteID
                ? connectedList.find((gp) => gp.id === state.remoteID)
                : null;

            await initGamepad(matchById || connectedList[0]);
        } finally {
            isHandlingGamepadsChange = false
        }
    }

    const onGamepadConnected = async () => {
        await handleGamepadsChange();
    }

    const saveJoystickSpecification = async (joystickSpecification: string): Promise<boolean> => {
        let param = {
            userId: store.state.persistence.userInfo.userId,
            tenantId: store.state.persistence.currentTenantId,
            joystickSpecification,
        }
        const { code, data } = await saveUserJoystickSpecification(param) as any
        if (code != $enum.EnumResult.SUCCESS || data !== true) {
            proxy?.vknMessage.error({
                message: '保存遥控器型号失败！',
                duration: messageDuration,
            })
            return false
        }
        store.commit('persistence/setUserTrainingSetting', {
            ...store.state.persistence.userTrainSettingInfo,
            joystickSpecification,
        })
        return true
    }

    const handleRemoteSelectChange = async (gamepadIndex: string) => {
        const gamepads = navigator.getGamepads();
        const gp = gamepads[Number(gamepadIndex)];
        if (gp && gp.connected && state.gamepadIndex !== gp.index) {
            playClickSound();
            await initGamepad(gp);
            if (state.gamepadIndex === gp.index && state.remoteID === gp.id) {
                await saveJoystickSpecification(gp.id);
            }
        }
    }
    const gamepaddisconnected = async () => {
        await handleGamepadsChange();
    }
    const onUpdateStickType = (data:ChannelItem,num:number)=>{ 
        const calibrateDisabledList = [];
        state.chanleList.forEach((item:ChannelItem,index:number)=>{
            if(num !== index && item.stickType === data.stickType && item.stickType){
                item.stickType=0;
                item.keyCode=''
            }else if(num === index && !data.stickType){
                item.keyCode=''
            }else if(num === index && data.stickType){
                if(item.keyCode!==''&& item.keyCode!=='throttle' &&  item.keyCode!=='roll' &&  item.keyCode!=='pitch' &&  item.keyCode!=='yaw'){
                    item.keyCode=''
                }
            }
            if(item.stickType===1 || item.stickType===2 || item.stickType===3 || item.stickType===4){
                calibrateDisabledList.push(item.stickType);
            }
        })
        if(calibrateDisabledList.length===4){
            state.calibrateDisabled=false
        }else{
            state.calibrateDisabled=true
        }
        playClickSound()

    }
    const onUpdateKeyType = (data:ChannelItem,num:number)=>{ 
        state.chanleList.find((item:ChannelItem,index:number)=>{
            if(num !== index && item.keyCode === data.keyCode){
                item.keyCode='';
                return true
            }
        })
        playClickSound()

    }

    const handleCalibrate = () => {
        state.showModal = true;
        handleAgainCalibrate()
        
    }
    
    const handleResetDefault = () => {
        window?.playClick()
        state.showPrompt = true;
    }
    const handleConfirmResetDefault = async () => {
        window?.playClick()
        await getKeyBindData(state.axesArray, -1)
    }

    const confirmCalibrate = ()=>{
        playClickSound()
        state.showModal = false
    }


    const playClickSound = ()=>{
        window?.playClick()
    }


    const handleClose = () => {
        state.showModal = false
        playClickSound()
    }

    const handleSave =async () =>{
        playClickSound()
        let keyBindingList:any[] = []
        const stickTypes=[]//用于验证是否摇杆设置错误
        const keyCodes = []//用于验证是否功能设置错误
        state.chanleList.forEach(item=>{
            if(item.keyCode){
                const obj:any= {
                    keyCode:item.keyCode,
                    // keyName:item.keyName,
                    keyValue:item.keyValue+'',
                    isInverse:item.reverse,
                    valueType:item.valueType,
                }
                if(item.valueType===2){
                    keyBindingList.push(obj)
                }else{
                    obj.stickCenterValue = item.stickCenterValue;
                    obj.stickMinValue = item.stickMinValue;
                    obj.stickMaxValue = item.stickMaxValue;
                    obj.stickType = item.stickType;
                    keyBindingList.push(obj)  
                }
                if(item.keyCode==='throttle'|| item.keyCode==='yaw'  || item.keyCode==='pitch' || item.keyCode==='roll'){
                    keyCodes.push(item.keyCode)
                }
            }
            if(item.stickType){
                stickTypes.push(item.stickType)
            }

        })
        if(stickTypes.length!==4){
            proxy?.vknMessage.error({
                message:"摇杆设置错误，请重新设置",
                duration: messageDuration,
            })
            return;
        }
        if(keyCodes.length!==4){
            proxy?.vknMessage.error({
                message:"功能设置错误，请重新设置",
                duration: messageDuration,
            })
            return;
        }

        // 修改按钮类型的通到的keyValue，需要减去axes长度
        keyBindingList = keyBindingList.map(item=>{
            if(item.valueType==2){
                item.keyValue = (Number(item.keyValue) - state.axesArray.length)+''
            }
            return item
        })
        
        let param = {
            userId:store.state.persistence.userInfo.userId,
            deviceType:1,
            joystickSpecification:state.remoteID,
            keyBindingList
        }
        state.loading = true
        console.log(param,"param")
        let {code,data} = await setUserKeybinding(param);
        state.loading = false
        if(code != $enum.EnumResult.SUCCESS || !data){
            proxy?.vknMessage.error({
                message:"设置遥控器参数失败！",
                duration: messageDuration,
            })
            return;
        }else{
            proxy?.vknMessage.success({
                message:"设置遥控器参数成功！",
                duration: messageDuration,
            })
        }
    }
    const setStickCenterValue =()=>{
        playClickSound()
        state.chanleList.forEach(item=>{
            if(item.stickType===1){
               item.stickCenterValue = item.value
            }else if(item.stickType===2){
                item.stickCenterValue = item.value
            }else if(item.stickType===3){
                item.stickCenterValue = item.value
            }else if(item.stickType===4){
                item.stickCenterValue = item.value
            }
        })
        countdownStart()
    }
    const onResetAnimationDiv=(isShowPoint=true)=>{
        const leftA1:any = document.querySelector('.leftA1');
        const leftB:any = document.querySelector('.leftB');
        const leftC:any = document.querySelector('.leftC');
        const leftD:any = document.querySelector('.leftD');
        const leftA2:any = document.querySelector('.leftA2'); 
        const rightA1:any = document.querySelector('.rightA1');
        const rightB:any = document.querySelector('.rightB');
        const rightC:any = document.querySelector('.rightC');
        const rightD:any = document.querySelector('.rightD');
        const rightA2:any = document.querySelector('.rightA2');
        const leftPoint:any = document.querySelector('.leftPoint');
        const rightPoint:any = document.querySelector('.rightPoint');
        leftA1.style.transform = 'scaleY(0)'
        leftA1.style.transitionDuration = '0s'
        leftA2.style.transform = 'scaleY(0)'
        leftA2.style.transitionDuration = '0s'
        leftB.style.transform = 'scaleX(0)'
        leftB.style.transitionDuration = '0s'
        leftC.style.transform = 'scaleY(0)'
        leftC.style.transitionDuration = '0s'
        leftD.style.transform = 'scaleX(0)'
        leftD.style.transitionDuration = '0s'
        rightA1.style.transform = 'scaleY(0)'
        rightA1.style.transitionDuration = '0s'
        rightA2.style.transform = 'scaleY(0)'
        rightA2.style.transitionDuration = '0s'
        rightB.style.transform = 'scaleX(0)'
        rightB.style.transitionDuration = '0s'
        rightC.style.transform = 'scaleY(0)'
        rightC.style.transitionDuration = '0s'
        rightD.style.transform = 'scaleX(0)'
        rightD.style.transitionDuration = '0s'
        leftPoint.style.top = '50%';
        leftPoint.style.left = '100%';
        leftPoint.style.display=isShowPoint?'block':'none'
        rightPoint.style.top = '50%';
        rightPoint.style.left = '0%';
        rightPoint.style.display=isShowPoint?'block':'none'
        if(state.isGetStickValueStart && state.isGetStickValueEnd){
            return;
        }
        const time = 312.5
        setTimeout(() => {
            leftA1.style.transform = 'scaleY(1)'
            leftA1.style.transitionDuration = `${time/1000}s`
            rightA1.style.transform = 'scaleY(1)'
            rightA1.style.transitionDuration = `${time/1000}s`
            leftPoint.style.top = '0%';
            leftPoint.style.transition=`top ${time/1000}s linear`;
            rightPoint.style.top = '0%';
            rightPoint.style.transition=`top ${time/1000}s linear`;
        }, 0);
        setTimeout(() => {
            leftB.style.transform = 'scaleX(1)'
            leftB.style.transitionDuration = `${time*2/1000}s`
            rightB.style.transform = 'scaleX(1)'
            rightB.style.transitionDuration = `${time*2/1000}s`
            leftPoint.style.left='0%';
            leftPoint.style.transition=`left ${time*2/1000}s linear`;
            rightPoint.style.left='100%';
            rightPoint.style.transition=`left ${time*2/1000}s linear`;
        }, 0+time);
        setTimeout(() => {
            leftC.style.transform = 'scaleY(1)'
            leftC.style.transitionDuration = `${time*2/1000}s`
            rightC.style.transform = 'scaleY(1)'
            rightC.style.transitionDuration = `${time*2/1000}s`
            leftPoint.style.top='100%';
            leftPoint.style.transition=`top ${time*2/1000}s linear`;
            rightPoint.style.top='100%';
            rightPoint.style.transition=`top ${time*2/1000}s linear`;
        },0+time+time*2);
        setTimeout(() => {
            leftD.style.transform = 'scaleX(1)'
            leftD.style.transitionDuration = `${time*2/1000}s`
            rightD.style.transform = 'scaleX(1)'
            rightD.style.transitionDuration = `${time*2/1000}s`
            leftPoint.style.left='100%';
            leftPoint.style.transition=`left ${time*2/1000}s linear`;
            rightPoint.style.left='0%';
            rightPoint.style.transition=`left ${time*2/1000}s linear`;
        },0+time+time*2+time*2);
        setTimeout(() => {
            leftA2.style.transform = 'scaleY(1)'
            leftA2.style.transitionDuration =  `${time/1000}s`
            rightA2.style.transform = 'scaleY(1)'
            rightA2.style.transitionDuration =  `${time/1000}s`
            leftPoint.style.top='50%';
            leftPoint.style.transition=`top ${time/1000}s linear`;
            rightPoint.style.top='50%';
            rightPoint.style.transition=`top ${time/1000}s linear`;
        },0+time+time*2+time*2+time*2);
        setTimeout(()=>{
            if(state.isGetStickValueStart && !state.isGetStickValueEnd){
                onResetAnimationDiv()
            }else{
                onResetAnimationDiv(false)
            }
        },0+time+time*2+time*2+time*2+time)
    }
    // 点击确认中心点
    const countdownStart = ()=>{ 
        state.stepTitle = '通道检查'
        state.stepContent = '旋转摇杆到最大值，直到倒计时结束'
        state.isGetStickValueStart = true
        state.isGetStickValueEnd = false
        state.stickType1Min=-0.3;
        state.stickType1Max=0.3;
        state.stickType2Min=-0.3;
        state.stickType2Max=0.3;
        state.stickType3Min=-0.3;
        state.stickType3Max=0.3;
        state.stickType4Min=-0.3;
        state.stickType4Max=0.3;
        const progress5:any = document.querySelector('.progress5');
        progress5.style.width = '0%'
        progress5.style.transitionDuration = '0s'
        progress5.style.width = '100%'
        progress5.style.transitionDuration = '5s'
        state.progress5Num=5;
        if (state.progress5Timer !== null) {
            clearInterval(state.progress5Timer)
            state.progress5Timer = null
        }
        state.progress5Timer = window.setInterval(() => {
            state.progress5Num -= 1
            if (state.progress5Num <=0) {
                state.progress5Num = 0 // 防止超过
                if (state.progress5Timer !== null) {
                    clearInterval(state.progress5Timer)
                    state.progress5Timer = null
                }
            }
        }, 1000)
        onResetAnimationDiv()
        setTimeout(() => {
            state.isGetStickValueStart = true;
            state.isGetStickValueEnd = true;
            onResetAnimationDiv(false)
            state.chanleList.forEach(item=>{
                if(item.stickType===1){
                    if(state.stickType1Min<-0.3){
                        item.stickMinValue = state.stickType1Min
                    }else{
                       item.stickMinValue = -1 
                    }
                    if(state.stickType1Max>0.3){
                        item.stickMaxValue = state.stickType1Max
                    }else{
                        item.stickMaxValue = 1
                    }
                }else if(item.stickType===2){ 
                    if(state.stickType2Min<-0.3){
                        item.stickMinValue = state.stickType2Min
                    }else{
                        item.stickMinValue = -1
                    }
                    if(state.stickType2Max>0.3){
                        item.stickMaxValue = state.stickType2Max
                    }else{
                        item.stickMaxValue = 1
                    }
                }else if(item.stickType===3){ 
                    if(state.stickType3Min<-0.3){
                        item.stickMinValue = state.stickType3Min
                    }else{
                        item.stickMinValue = -1
                    }
                    if(state.stickType3Max>0.3){
                        item.stickMaxValue = state.stickType3Max
                    }else{
                        item.stickMaxValue = 1
                    }
                }else if(item.stickType===4){
                    if(state.stickType4Min<-0.3){
                        item.stickMinValue = state.stickType4Min
                    }else{
                        item.stickMinValue = -1
                    }
                    if(state.stickType4Max>0.3){
                        item.stickMaxValue = state.stickType4Max
                    }else{
                        item.stickMaxValue = 1
                    }
                }
            })  
        },5000);
    }
    const handleAgainCalibrate = ()=>{ 
        playClickSound()
        state.isGetStickValueStart=false;
        state.isGetStickValueEnd=true;
        state.stepTitle = '遥感中位'
        state.stepContent = '保持摇杆中位，点击“确定”'

        const progress5:any = document.querySelector('.progress5');
        progress5.style.width = '0%'
        progress5.style.transitionDuration = '0s'
    }

    // 获取摇杆中位
    function getJoystickPercentage(item:any) {
        let percent;
        if (item.value <item.stickCenterValue) {
            percent = 50 * (item.value - item.stickMinValue) / (item.stickCenterValue - item.stickMinValue);
        } else {
            percent = 50 + 50 * (item.value - item.stickCenterValue) / (item.stickMaxValue - item.stickCenterValue);
        }
        if (item.reverse) {
            percent = 100 - percent;
        }
        return Math.max(0, Math.min(100, percent));
    }

    const handleJumpTutorial = ()=>{
        window.open('https://www.bilibili.com/video/BV1HoF6ziEut/?spm_id_from=333.1387.homepage.video_card.click', '_blank')
    }
    ///////////////////////////////////////// 生命周期
    onBeforeMount(() => {
        initData()
    })
    onMounted(()=>{
        if ('getGamepads' in navigator) {
            const gamepads = navigator.getGamepads();
            if(!gamepads.forEach){
                proxy?.vknMessage.info({
                    message:"您的浏览器不支持Gamepad API，请更换浏览器",
                    duration: messageDuration,
                });
                return;
            }
            const connectedList = getConnectedGamepads();
            if (connectedList.length > 0) {
                handleGamepadsChange();
            }
            window.addEventListener('gamepadconnected', onGamepadConnected);
            window.addEventListener('gamepaddisconnected', gamepaddisconnected);
            startConnectionWatch();

        } else {
            proxy?.vknMessage.info({
                message:"您的浏览器不支持Gamepad API，请更换浏览器",
                duration: messageDuration,
            });
        }
    })
    onBeforeUnmount(() => {
        window.removeEventListener('gamepadconnected', onGamepadConnected);
        window.removeEventListener('gamepaddisconnected', gamepaddisconnected);
        stopConnectionWatch();
        stopAnimation();
    })

    return {
        ...toRefs(state),
        remoteIcon,
        remoteName,
        disconnect,
        stickTypeList,
        handleCalibrate,
        handleResetDefault,
        handleClose,
        handleSave,
        onUpdateStickType,
        onUpdateKeyType,
        setStickCenterValue,
        handleAgainCalibrate,
        getJoystickPercentage,
        playClickSound,
        confirmCalibrate,
        handleJumpTutorial,
        handleConfirmResetDefault,
        handleRemoteSelectChange,
    }
}